import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography, Box, CircularProgress, Button, ButtonGroup } from "@mui/material";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import { getRequest, server } from "../config";

// Register Chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [analytics, setAnalytics] = useState({
    totalBookings: 0,
    totalCustomers: 0,
    totalPartners: 0,
  });
  const [chartData, setChartData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("Today");
  const [bookingCounts, setbookingCounts] = useState(0)

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        setLoading(true);

        // Fetch total counts
        const [bookingsRes, customersRes, partnersRes] = await Promise.all([
          getRequest(server.uri+"service-requests/count"),
          getRequest(server.uri+`users/count?where={"userType":"customer"}`),
          getRequest(server.uri+`users/count?where={"userType":"partner"}`),
        ]);

        setAnalytics({
          totalBookings: bookingsRes.count,
          totalCustomers: customersRes.count,
          totalPartners: partnersRes.count,
        });

        // Fetch initial chart data for "Today"
        await fetchChartData("Today");

        setLoading(false);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  const fetchChartData = async (filter) => {
    setLoading(true);
    try {
      const filterDate = getFilterDate(filter);
      const response = await axios.get(`${server.uri}api/analytics?filterType=${filter}`);


     
     let sum=0;
      const findTotal=response?.data?.bookings?.map((item)=>{sum+=parseInt(item?.count)})
setbookingCounts(sum)
      setChartData(response?.data?.bookings);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching chart data:", error);
      setLoading(false);
    }
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    fetchChartData(filter);
  };

  const getFilterDate = (filter) => {
    const now = new Date();
    switch (filter) {
      case "Today":
        return new Date().toISOString().split("T")[0];
      case "This Week":
        return new Date(now.setDate(now.getDate() - now.getDay())).toISOString().split("T")[0];
      case "This Month":
        return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split("T")[0];
      case "This Year":
        return new Date(now.getFullYear(), 0, 1).toISOString().split("T")[0];
      case "Last Year":
        return new Date(now.getFullYear()-1, 0, 1).toISOString().split("T")[0];
      default:
        return new Date().toISOString().split("T")[0];
    }
  };

  const bookingsChartConfig = {
    labels: chartData.map((data) => data.date),
    datasets: [
      {
        label: "Bookings",
        data: chartData.map((data) => data.count),
        backgroundColor: "#1976d2",
      },
    ],
  };

  return (
    <Box sx={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {/* Key Metrics */}
          <Grid item xs={12} md={3}>
            <Paper sx={{ padding: 3, textAlign: "center" }}>
              <Typography variant="h6">Total Bookings</Typography>
              <Typography variant="h4" color="primary">
                {analytics.totalBookings}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={3}>
            <Paper sx={{ padding: 3, textAlign: "center" }}>
              <Typography variant="h6">Total Customers</Typography>
              <Typography variant="h4" color="info">
                {analytics.totalCustomers}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={3}>
            <Paper sx={{ padding: 3, textAlign: "center" }}>
              <Typography variant="h6">Total Partners</Typography>
              <Typography variant="h4" color="warning">
                {analytics.totalPartners}
              </Typography>
            </Paper>
          </Grid>

          {/* Filter Buttons */}
          <Grid item xs={12}>
            <ButtonGroup variant="contained">
              {["Today", "This Week", "This Month", "This Year","Last Year"].map((filter) => (
                <Button
                  key={filter}
                  onClick={() => handleFilterChange(filter)}
                  color={selectedFilter === filter ? "primary" : "default"}
                >
                  {filter}
                </Button>
              ))}
            </ButtonGroup>
          </Grid>

          {/* Bookings Analysis */}
          <Grid item xs={12}>
            <Paper sx={{ padding: 3 }}>
              <Typography variant="h6" gutterBottom>
                Bookings Analysis - {selectedFilter} ({bookingCounts})
              </Typography>
              <Bar data={bookingsChartConfig} />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Dashboard;
